import { Component, OnInit, Input, Output, EventEmitter, AfterViewChecked, AfterViewInit } from '@angular/core';
import * as moment from 'moment';
import { Subject, timer } from 'rxjs';
import { debounce, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css']
})
export class DatePickerComponent implements OnInit, AfterViewInit {


  @Input() prop : any;
  @Output() modelChanged = new EventEmitter<any>();
  @Output() changeComplete = new Subject<any>();
  @Input() setMinimum : boolean;
  @Input() setMaximum : boolean;
  @Input() onClear : Subject<any>;
  @Input() elementId : string;
  @Input() showTimeParts : boolean = true;
  @Input() label : string;
  @Input() placeholder : Date;
  @Input() outputMoment : boolean = true;
  @Input() year : string;
  @Input() month : string;
  @Input() day : string;
  @Input() hours : string;
  @Input() minutes : string;
  @Input() am : string;

  outMoment : moment.Moment;

  partialDate : boolean;
  fullDate : boolean;

  inputElements : NodeListOf<Element>;

  constructor ()
  {
    this.modelChanged.pipe(debounce(()=> timer(3000)), distinctUntilChanged());

  }

  changesComplete() {
    if(this.changeComplete) {
      this.changeComplete.next({
        name: this.prop,
        value: this.outMoment.toDate()
      })
    }
  }

  ngAfterViewInit(): void {
    if(this.onClear) {
      this.onClear.subscribe((val) => {
      this.clearInput();
    })};

    if(this.placeholder) {
      let newDate = new Date(this.placeholder);
      this.year = newDate.getFullYear().toString();
      //months are 0 based index for some reason...
      this.month = (newDate.getMonth()+1).toString();
      this.day = newDate.getDate().toString();
    }

    //set those mins and maxes if needed
    if(this.setMaximum) {
      this.hours = "11";
      this.minutes = "59";
      this.am = "PM";
    }
    else if(this.setMinimum) {
      this.hours = "00";
      this.minutes = "00"
      this.am = "AM"
    } else {
      this.hours = null;
      this.minutes = null
      this.am = null
    }

    let parent = document.getElementById(this.elementId);
    if(parent) this.inputElements = parent.querySelectorAll('[class*="-input"]');
  }

  ngOnInit() {
  }

  clearInput() : void {
    this.year = null;
    this.month = null;
    this.day = null;
    if(this.setMaximum) {
      this.hours = "11";
      this.minutes = "59";
      this.am = "PM";
    }
    else if(this.setMinimum) {
      this.hours = "00";
      this.minutes = "00"
      this.am = "AM"
    } else {
      this.hours = null;
      this.minutes = null
      this.am = null
    }
    this.partialDate = null;
    this.fullDate = null;
  }

  changes() {
    this.outMoment = moment();
    if((this.year && this.year.length == 4)
      && (this.day && this.day.length <= 2)
      && (this.month && this.month.length <= 2)) {
      this.partialDate = true;
    }
    if(this.partialDate && (this.hours && this.hours.length <= 2 && this.hours.length > 0)
      && (this.minutes && this.minutes.length <= 2 && this.minutes.length > 0)) {
        this.fullDate = true;
      this.partialDate = false;

    }

    if(this.partialDate) {
      this.outMoment.year(parseInt(this.year));
      this.outMoment.month(parseInt(this.month)-1);
      this.outMoment.date(parseInt(this.day));
      if(this.setMinimum) {
        this.outMoment.hour(0);
        this.hours = "00";
        this.outMoment.minutes(0);
        this.minutes = "00";
        this.outMoment.seconds(0);
        this.am = "AM";
      }
      if(this.setMaximum) {
        this.outMoment.hour(23);
        this.hours = "11";
        this.outMoment.minutes(59);
        this.minutes = "59";
        this.am = "PM";
      }
      if(this.outputMoment) {
        this.modelChanged.emit({
          property : this.prop,
          time : this.outMoment
        });
      } else {
        //this is a specific use case on the screening edit view.
        //TODO: come back and make this usable elsewhere
        this.modelChanged.emit({
          name : this.prop,
          value : this.outMoment.toDate()
        })
      }
    }

    if(this.fullDate) {
      this.outMoment.year(parseInt(this.year));
      this.outMoment.month(parseInt(this.month)-1);
      this.outMoment.date(parseInt(this.day));
      // this.am ? outputMoment.hours(parseInt(this.hours)) : outputMoment.hours(parseInt(this.hours+12));
      this.outMoment.hours(this.am == 'AM' ? parseInt(this.hours) : parseInt(this.hours)+12);
      this.outMoment.minutes(parseInt(this.minutes));
      this.outMoment.seconds(0);
      this.modelChanged.emit({
        property : this.prop,
        time : this.outMoment
      });
    }
  }
}
